import {ChangeDetectorRef, Component, forwardRef, Optional} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUITextareaControlComponent),
            multi: true
        }
    ],
    selector: "fui-textarea-control",
    templateUrl: "./textarea-control.component.html",
    standalone: false
})
export class FUITextareaControlComponent extends FUIAbstractControl {
    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
    }
}
